import { gql } from "lib/apolloClient";
import { userCoursesPageFragment } from "./GlobalSearchBarFragment";

export const getGlobalSearchResult = gql`
  query getGlobalSearchResultQuery(
    $searchText: String
    $platformSearchEntities: [PLATFORM_SEARCH_ENTITY_ENUM!]
    $maxCountPerType: Int!
    $scope: SEARCH_SCOPE_ENUM!
    $academicYear: ID!
    $curriculum: ID
    $curriculumIds: [ID]!
    $metadata: JSON!
  ) {
    platform {
      platformSearch(
        input: {
          searchText: $searchText
          platformSearchEntities: $platformSearchEntities
          maxCountPerType: $maxCountPerType
          scope: $scope
          academicYear: $academicYear
          curriculum: $curriculum
          curriculumIds: $curriculumIds
          metadata: $metadata
        }
      ) {
        id
        type
        metadata
        title
        subTitle
        order
      }
    }
  }
`;

export const getUserCoursesQuery = gql`
  query getUserCourses(
    $id: ID!
    $type: ENTITY_TYPE_ENUM!
    $filters: CourseFilter
  ) {
    node(id: $id, type: $type) {
      id
      ... on Staff {
        id
        courses(filters: $filters, orderBy: TITLE, orderByDirection: ASC) {
          id
          title
          curriculumProgram {
            id
            type
            nodeInterfaceType
            label
            acronym
          }
          profileImageData {
            url
            icon
          }
          subjects {
            id
            type
            subjectGroup {
              id
            }
          }
          subjectGroups {
            id
            type
          }
          grades {
            id
            displaySequence
          }
        }
      }
    }
  }
`;

export const getUbdAssessmentTypesMultiNodeQuery = gql`
  query getUbdAssessmentTypesMultiNode(
    $ids: [ID!]
    $type: ENTITY_TYPE_ENUM_MULTI_NODE!
  ) {
    multiNode(ids: $ids, type: $type) {
      id
      ... on UBDCurriculumProgram {
        id
        assessmentTypes {
          id
          uid
          label
          metadata
        }
      }
    }
  }
`;

export const getUserCoursesV2Query = gql`
  query getUserCoursesV2($userId: ID!, $courseFilters: CourseFilter) {
    node(id: $userId, type: STAFF) {
      id
      ...staffCourses
    }
  }

  ${userCoursesPageFragment}
`;
